import React from "react";
import "./CreditsHeader.css";

export default function CreditsHeader({ title, subtitle }) {
  return (
    <div className="credits-header">
      <h1 className="credits-header-title">{title}</h1>
      {subtitle && <p className="credits-header-subtitle">{subtitle}</p>}
    </div>
  );
}
